// Extracted from the `list.campaignMetrics` + `list.campaignRollup` namespaces of en.ts so the
// (over-length) main translation file stays within the architecture-gate line ratchet. Spread back
// in under their original `list.*` keys in en.ts.
export const enListCampaignMetrics = {
	contacted: "Contacted",
	replied: "Replied",
	positive: "Positive",
};

export const enListCampaignRollup = {
	allActive: "All campaigns active",
	partiallyActive: "Campaigns partially active",
	allPaused: "All campaigns paused",
	allEnded: "All campaigns ended",
	none: "No valid campaigns",
	contacted: "contacted",
	positive: "positive",
	manage: "Manage campaigns",
	campaigns: "Campaigns",
	create: "Create a campaign",
	createNew: "Create a new campaign",
	view: "View campaigns",
	// "Ended" since PREC-4291; the key keeps its old name.
	completedColumn: "Ended",
	completedColumnHint:
		"Leads that finished this campaign: the sequence ended, the last message was sent, they replied, or they were marked done. Matches “Ended Campaigns” in Analytics.",
	contactedColumn: "Contacted",
	contactedColumnHint: "Leads with at least one message sent.",
	outboxLinkHint: "Open this campaign's leads in the Outbox, under “{{tab}}”",
	// The "Make default campaign" hint (PREC-4219): routing rules decide first, then the fallback.
	makeDefaultHint:
		"Leads that no routing rule matches go to the default campaign, unless the list's routing is set to leave them unassigned (see Auto-assign routing below the table). Only one campaign can be default.",
};
